import {Component,type ReactNode} from 'react'
/** Split route assets can be interrupted by a network error or deployment.
 * Keep navigation available and let the user reload the current URL explicitly. */
export default class RouteLoadingBoundary extends Component<{children:ReactNode;onRetry?:()=>void},{failed:boolean}>{
 state={failed:false}
 static getDerivedStateFromError(){return{failed:true}}
 render(){return this.state.failed?<section className="panel"><div className="state" role="alert"><p>页面暂未能打开，请检查网络后重试。</p><button className="btn" onClick={()=>this.props.onRetry?this.props.onRetry():window.location.reload()}>重新加载当前页面</button></div></section>:this.props.children}
}
